<template>
  <div id="smartEnergyPage">
    <el-row class="contentCls">
      <el-col :span="4">
        <el-menu default-active="1" @select="selectedMenu">
          <el-menu-item index="1">
            <!-- <i class="el-icon-document"></i> -->
            <span slot="title">热水系统</span>
          </el-menu-item>
          <el-menu-item index="2">
            <!-- <i class="el-icon-setting"></i> -->
            <span slot="title">采暖系统</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="20">
        <hot-water-smart v-if="isHotWaterSystem"></hot-water-smart>
        <heating-smart v-if="isHeatingSystem"></heating-smart>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import HotWaterSmart from "./smartSystems/hotWaterSmart.vue";
import HeatingSmart from "./smartSystems/heatingSmart.vue";

export default {
  name: "smartEnergyPage",
  components: {
    HotWaterSmart,
    HeatingSmart,
  },
  data() {
    return {
      isHotWaterSystem: true,
      isHeatingSystem: false,
    };
  },
  props: {},
  mounted() {},
  methods: {
    selectedMenu(index) {
      switch (index) {
        case "1":
          this.isHotWaterSystem = true;
          this.isHeatingSystem = false;
          break;
        case "2":
          this.isHeatingSystem = true
          this.isHotWaterSystem = false;
          break;
      }
    },
  },
};
</script>

<style scoped>
#smartEnergyPage {
  width: 100%;
  height: 100%;
}
.contentCls {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/smartEnergyPage.vue